module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-address-recognition"
  }, [_c('rt-form', {
    attrs: {
      "model": _vm.editForm,
      "border": ""
    }
  }, [_c('rt-form-item', {
    attrs: {
      "hidden-label": ""
    }
  }, [_c('rt-input', {
    attrs: {
      "type": "textarea",
      "placeholder": _vm.placeholder,
      "autosize": {
        minRows: 3,
        maxRows: 5
      }
    },
    model: {
      value: (_vm.editForm.text),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "text", $$v)
      },
      expression: "editForm.text"
    }
  }, [_c('template', {
    slot: "textareaSuffix"
  }, [_vm._t("button", function() {
    return [_c('rt-button', {
      staticClass: "el-input__count",
      attrs: {
        "type": "plain",
        "text": ""
      },
      on: {
        "click": _vm.onClick
      }
    }, [_vm._v("\n              " + _vm._s(_vm.buttonText) + "\n            ")])]
  })], 2)], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rt-address-recognition-tips"
  }, [_vm._v("\n    " + _vm._s(_vm.tips) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c8aea88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/address/rtRecognition.vue
// module id = 2029
// module chunks = 228